import React, { useEffect, useState } from 'react';
import Classes from './Settings.module.css';
import InfoTab from './Comp/InfoTab';
import ResetPassword from './Comp/ResetPassword';
import VehiclesTab from './Comp/VehiclesTab';
import Membership from './Comp/Membership/Membership';
import { useNavigate, useParams } from 'react-router-dom';

export default function Settings() {
    const navigateTo = useNavigate();
    const { tab } = useParams();
    const [activeTab, setactiveTab] = useState(tab);

    useEffect(() => {
        setactiveTab(tab);
    }, [tab])

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <div>
                    <h3 className={Classes.title3}>Settings</h3>
                    <h5 className={Classes.text}>Manage your account settings.</h5>
                </div>
            </div>

            <div className={Classes.navigation}>
                <button
                    className={`${Classes.btn1} ${activeTab === 'profile' ? Classes.activeBtn : ''}`}
                    onClick={() => navigateTo('/settings/profile')}
                >
                    <h5>Profile</h5>
                </button>
                <button
                    className={`${Classes.btn2} ${activeTab === 'vehicles' ? Classes.activeBtn : ''}`}
                    onClick={() => navigateTo('/settings/vehicles')}
                >
                    <h5>Vehicles</h5>
                </button>
                <button
                    className={`${Classes.btn3} ${activeTab === 'membership' ? Classes.activeBtn : ''}`}
                    onClick={() => navigateTo('/settings/membership')}
                >
                    <h5>Membership</h5>
                </button>
                <button className={Classes.btn4}>
                    <h5>Log Out</h5>
                </button>
            </div>

            {activeTab === 'profile' && (
                <>
                    <h3 className="mb-20">Profile</h3>
                    <InfoTab />
                    <h3 className="mb-20">Reset Password</h3>
                    <ResetPassword />
                </>
            )}
            {activeTab === 'vehicles' && <VehiclesTab />}
            {activeTab === 'membership' && <Membership />}
        </div>
    );
}
